import styled, { css } from 'styled-components';
import AntTypography from 'antd-core/es/typography/Text';
import { fontWeight, wordBreak, color, uppercase, margin, width, height, whiteSpace, textAlign } from '@10d/tend-ui-styling';
import { fontSize } from '../styled.js';

const Root = styled(AntTypography) `
  &.tend-ui-typography-text {
    ${fontSize};
    ${fontWeight};
    ${wordBreak};
    ${color};
    ${uppercase};
    ${margin};
    ${width};
    ${height};
    ${whiteSpace};
    ${props => [
    props.$width,
    props.$height,
    props.$marginTop,
    props.$marginRight,
    props.$marginBottom,
    props.$marginLeft,
    props.$margin,
].some(Boolean) &&
    css `
        display: inline-block;
      `}
    ${props => props.$textAlign &&
    css `
        display: inline-block;
        ${textAlign};
      `}
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
